"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fulfilPaymentAdviceRequestSchema = exports.rejectPaymentAdviceRequestSchema = exports.paymentAdviceWorkflowActionRequestSchema = exports.createPaymentAdviceRequestSchema = exports.issueVendorAdjustmentRequestSchema = exports.vendorAdvanceSettleRequestSchema = exports.vendorAdvanceMovementRequestSchema = exports.openVendorAdvanceAccountRequestSchema = exports.apAgeingQuerySchema = exports.apOutstandingQuerySchema = exports.apLedgerQuerySchema = exports.convertOverpaymentToAdvanceRequestSchema = exports.resolveVendorOverpaymentRequestSchema = exports.allocatePaymentAutomaticallyRequestSchema = exports.allocatePaymentRequestSchema = exports.createVendorPaymentRequestSchema = exports.cancelVendorInvoiceRequestSchema = exports.writeOffVendorInvoiceRequestSchema = exports.createVendorInvoiceRequestSchema = void 0;
/**
 * Request contracts for Accounts Payable (Stage 13, Milestone 2 Part
 * 2) — `VendorInvoiceApplicationService`/`VendorPaymentApplicationService`/
 * `VendorPaymentAllocationApplicationService`/`VendorAdvanceApplicationService`/
 * `VendorAdjustmentApplicationService`/`ApLedgerApplicationService`/
 * `PaymentAdviceApplicationService`
 * (`backend/src/modules/financial/payable/`).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
const vendorInvoiceTypeSchema = zod_1.z.enum(['PURCHASE', 'EXPENSE']);
const createVendorInvoiceLineSchema = zod_1.z.object({
    itemId: zod_1.z.string().uuid().optional(),
    description: zod_1.z.string().min(1).max(255),
    grossAmount: zod_1.z.number().int().nonnegative(),
    discountAmount: zod_1.z.number().int().nonnegative().optional(),
    taxAmount: zod_1.z.number().int().nonnegative().optional(),
    netAmount: zod_1.z.number().int().nonnegative(),
});
exports.createVendorInvoiceRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    hospitalId: zod_1.z.string().uuid().optional(),
    invoiceType: vendorInvoiceTypeSchema,
    vendorId: zod_1.z.string().uuid(),
    vendorInvoiceRef: zod_1.z.string().min(1).max(100),
    expenseAccountId: zod_1.z.string().uuid(),
    invoiceDate: zod_1.z.coerce.date(),
    dueDate: zod_1.z.coerce.date().optional(),
    lines: zod_1.z.array(createVendorInvoiceLineSchema).min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.writeOffVendorInvoiceRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.cancelVendorInvoiceRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
const createVendorPaymentLineSchema = zod_1.z.object({
    paymentModeId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    referenceNumber: zod_1.z.string().max(100).optional(),
});
exports.createVendorPaymentRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    vendorId: zod_1.z.string().uuid(),
    totalAmount: zod_1.z.number().int().positive(),
    paymentDate: zod_1.z.coerce.date().optional(),
    remarks: zod_1.z.string().optional(),
    lines: zod_1.z.array(createVendorPaymentLineSchema).min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.allocatePaymentRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.allocatePaymentAutomaticallyRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    vendorId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.resolveVendorOverpaymentRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.convertOverpaymentToAdvanceRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.apLedgerQuerySchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid(),
    from: zod_1.z.coerce.date().optional(),
    to: zod_1.z.coerce.date().optional(),
});
exports.apOutstandingQuerySchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
});
exports.apAgeingQuerySchema = zod_1.z.object({
    asOfDate: zod_1.z.coerce.date().optional(),
    branchId: zod_1.z.string().uuid().optional(),
});
exports.openVendorAdvanceAccountRequestSchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.vendorAdvanceMovementRequestSchema = zod_1.z.object({
    amount: zod_1.z.number().int().positive(),
    paymentId: zod_1.z.string().uuid().optional(),
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.vendorAdvanceSettleRequestSchema = zod_1.z.object({
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.issueVendorAdjustmentRequestSchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
const paymentAdviceLineSchema = zod_1.z.object({
    invoiceId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
});
exports.createPaymentAdviceRequestSchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid(),
    proposedDate: zod_1.z.coerce.date(),
    lines: zod_1.z.array(paymentAdviceLineSchema).min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.paymentAdviceWorkflowActionRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.rejectPaymentAdviceRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.fulfilPaymentAdviceRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    paymentModeId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
//# sourceMappingURL=financial-payable.request.js.map